import { createAuthClient } from 'better-auth/react'
import { apiBaseUrl } from './api.ts'

// The api mounts better-auth at /auth (not its /api/auth default), so the
// base URL carries the path. Cookies are cross-origin (admin -> api), hence
// credentials: 'include' on every auth request.
export const authClient = createAuthClient({
  baseURL: `${apiBaseUrl}/auth`,
  fetchOptions: { credentials: 'include' },
})
